import React from "react";
import { CanDoForYouProps } from "../../../../../components/can-do-for-you/types";
import { StaticImage } from "gatsby-plugin-image";
import {Translate} from "../../../../../locales/locales-utils";
const staticImageStyle = { width: "100%", borderRadius: "8px 8px 0px 0px" };

export const canDoForYouProps = (): CanDoForYouProps => {
  return  {
    title: Translate("Index.Landings.Title"),
    cards: [
      {
        text: Translate("Index.Landings.Items.0"),
        href: "/sport/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/sport.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#2811B3"
      },
      {
        text: Translate("Index.Landings.Items.1"),
        href: "/brand-promotion/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/brand-ad.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#EE426A"
      },
      {
        text: Translate("Index.Landings.Items.2"),
        href: "/lead-generation/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/lead-generation.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#5A00A0"
      },
      {
        text: Translate("Index.Landings.Items.3"),
        href: "/private-event/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/uniq-event.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#FFA900"
      },
      {
        text: Translate("Index.Landings.Items.4"),
        href: "/events/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/conference.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#FF6753"
      },
      {
        text: Translate("Index.Landings.Items.5"),
        href: "/team-building/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/hr.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#7A74FF"
      },
      {
        text: Translate("Index.Landings.Items.6"),
        href: "/training/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/training-webinar.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#00A3FF"
      },
      {
        text: Translate("Index.Landings.Items.7"),
        href: "/education/",
        img: (
            <StaticImage
                src={"../../../../../images/pages/ru-index/can-do-for-you/learning.png"}
                alt={""}
                style={staticImageStyle}
                placeholder="blurred"
            />
        ),
        color: "#65C15D"
      }
    ],
    buttonText: Translate("Index.Landings.LoadMore")
  }
};
